// Entered values are chained into a_FORCE comma-delimited, so the delimiter
// characters must be escaped: '&' -> '&amp;', ',' -> '&#x2c;'.
// '&' is escaped first so the '&' introduced by the comma entity stays intact.
export const escapeEntryValue = (value: string): string =>
  value.replace(/&/g, '&amp;').replace(/,/g, '&#x2c;');
